import ServiceExec from '@/common/utils/ServiceExec';
import { CODE_ENV_LIST } from '@/common/constants/ConstCode';
const { GOOGLE_MAPS_KEY } = CODE_ENV_LIST;
export default {
  async query({ commit }, query) {
    const { status, data } = await ServiceExec.get('/common/maps', {
      query: encodeURI(query)
    });

    if (status == 200) commit('setPredicates', data.predictions);
  }
};
